import { render, staticRenderFns } from "./ActivateWhatsappAlert.vue?vue&type=template&id=b7524a90"
import script from "./ActivateWhatsappAlert.vue?vue&type=script&lang=js"
export * from "./ActivateWhatsappAlert.vue?vue&type=script&lang=js"
import style0 from "./ActivateWhatsappAlert.vue?vue&type=style&index=0&id=b7524a90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports